import React from "react";
import logo from "../Asset/logo.png";
import twent24 from "../Asset/24-7.png";
import milestone from "../Asset/IHM-Milestone.jpg";
import ihmfooter from "../Asset/ihm_footer.png";
import sideImg from "../Asset/744.jpg";
import AuthService from "../Authentication/AuthService";
import "../Asset/css/staticDashboard.css";

class StaticDashboard extends React.Component {
  authService;
  constructor(props) {
    super(props);
    this.authService = new AuthService();
    this.state = {
    };
  }
  componentDidMount() {
    window.location.href = process.env.REACT_APP_PRODUCTS_PAGE_ENDPOINT;

  }

  /* login = () => {
    this.props.history.push('/login');
  } */

  render() {
    return (
      <div></div>
     // <div className="row">
      //  <div className="col-sm-12 col-md-12">
        /*   <div className="app-header" style={{ borderBottom: "none" }}>
            <div className="site-header-inner my-1">
              <div className="row wid100 ml-0" style={{ maxWidth: '100%', flex: '0 0 100%' }}>
                <div className="col-sm-6 col-md-6">
                  <a href="#" style={{ padding: "0.5rem 1rem" }}>
                    <img className="logo-image" src={logo}></img>
                  </a>
                </div>
                <div className="col-sm-6 col-md-6 text-right">
                  <div className="mt-2">
                    <button className="btn btn-primary my-2 my-sm-0" type="submit" onClick={() => this.login()}>Login</button>
                  </div>
                </div>
              </div>
            </div>
          </div> */
        /*   <div className="wrap min-ht">
            <div className="wrap-sub">
              <div className="wrap">
                <div className="col-12 col-sm-8 pull-left customStyle">
                  <h1 style={{ textAlign: "left", color: "silver" }}>ALCOVIZOR</h1>
                </div>
                <div className="col-12 col-sm-4 pull-right">
                  <div className="wrap">
                    <div className="col-3" style={{ marginLeft: "-15px" }}><img src={twent24} className="img-fluid" alt="" /></div>
                    <div className="col-9 vercent customStyle">
                      <p style={{ fontSize: "16px", color: "whitesmoke", padding: "0", margin: "0" }}><strong>24x7 Technical Support</strong></p>
                      <p className="copytext" style={{ fontSize: "14px", color: "whitesmoke", lineHeight: "18px" }}>Email: <a href="mailto:technical@marinemechanics.biz">technical@marinemechanics.biz</a><br />
                           Phone : +91  7810012222
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="wrap cpad25">
              <div className="wrap cpad25 border-bot">
                <div className="col-sm-4 wow fadeInUp"><img src={sideImg} className="img-fluid" alt="" /></div>
                <div className="col-sm-8 wow fadeInUp customStyle">
                  <p><strong>World's First 24x7 Manned Center</strong> equipped with experts of NavCom and SatCom under same roof.</p>
                  <p>We have well experienced team who are in direct touch with various makers globally. When a problem is reported, a unique Case-ID is created in the system and assigned to global service support team.</p>
                  <p>In our experience, more than 40% of reported problems have been resolved on E-Mail &amp; Phone communications, resulting in substantial savings for ship owners.</p>
                  <p><strong>To ensure maximum uptime of ships systems, We support ships thru 4 Tier support system -</strong></p>
                  <h5>RMS - Remote Maintenance Support</h5>
                  <p>The Team &lsquo;passionate  about inner Engineering &lsquo;  is manning the Marine call centre &ndash; 24X7 &ndash; 365 days to support ships while at sea with pure technical support ( no commerce).</p>
                  <h5>BMS - Breakdown Maintenance Support</h5>
                  <p>Just in case needed, irrespective of make &amp; model ,our skilled &amp; trained team is ready to jump onboard for repair services for full Bridge systems (NavCom), Power Generation &amp; Distribution systems, Controls &amp; Automation systems.</p>
                  <h5>PMS - Preventive Maintenance Support</h5>
                  <p>With our sea experience, we strongly recommend to carry out preventive maintenance of ships fitted systems &amp; units &ndash; to avoid sudden breakdowns.</p>
                  <h5>AMS - Annual Maintenance Support</h5>
                  <p>We have dedicated softwares &amp; dedicated experienced staff to maintain records &amp; support you as required.</p>
                </div>
              </div>
            </div>
          </div> */
         /*  <div className="footer p-5">
            <div className="row">
              <div className="col-xs-12 col-sm-4 copytext" style={{ textAlign: "center" }}>
                Copyright &copy; 2018 Marine Mechanics Pvt Ltd  <br /> All Rights Reserved.
            </div>
              <div className="col-xs-10 col-sm-3 copytext" style={{ textAlign: "center" }}>
                Design &amp; Developed by  -<a href="http://www.aristowebtek.in"><br /> Aristo Creative Technologies</a> 
              </div>
              <div className="col-xs-2 col-sm-1 copytext" style={{ textAlign: "center" }}>
                <a href="/!hm2k!908-27"><img src={ihmfooter} className="img-fluid" target="_blank" alt="ihm" /></a>
              </div>
              <div className="col-xs-12 col-sm-4" style={{ textAlign: "center" }}>
                <a href="https://www.facebook.com/MarineMechanics.biz" target="_blank"><i className="footerIcon fa fa-facebook p-2"> </i></a><a href="https://twitter.com/MechanicsMarine" target="_blank"><i className="footerIcon fa fa-twitter p-2"></i></a><a href="https://www.linkedin.com/company/marine-mechanics-pvt-ltd/" target="_blank"><i className="footerIcon fa fa-linkedin p-2"></i></a><a href="https://www.instagram.com/marinemechanics.biz/" target="_blank"><i className="footerIcon fa fa-comment p-2"></i></a><a href="https://plus.google.com/100366615227246141522" target="_blank"><i className="footerIcon fa fa-google-plus p-2"></i></a><a href="https://www.youtube.com/channel/UCS1tRVE9qIJFo5MhlDxeMig" target="_blank"><i className="footerIcon fa fa-youtube p-2"></i></a><a href="mailto:technical@marinemechanics.biz" target="_parent"><i className="footerIcon fa fa-envelope p-2"></i></a>
              </div>
            </div>
          </div> */
      //  </div>
     // </div>
    );
  }
}

export default StaticDashboard;
